/**
 * A cross-origin `<link rel="manifest">` fetch failure (wrong CORS headers, 404, network error)
 * is logged by the browser engine itself, outside any JS-observable channel -- not through
 * `console.*`, not as a `window` `error`/`unhandledrejection` event, not even as an `error` event
 * on the `<link>` element. This was verified with one manual chrome-devtools check against a
 * live CORS failure (none of those channels fired); it has not been confirmed across browser
 * engines or CORS failure modes beyond that single case. In the verified case, it does not reach
 * smash-telemetry's console/global-error capture, whatever the SDK's own instrumentation. This performs the
 * same fetch ourselves and reports failure through `console.error`, which telemetry DOES capture,
 * so the underlying condition is visible even though the browser's own diagnostic never will be.
 */
export function checkManifestReachability(): void {
    const link = document.querySelector<HTMLLinkElement>('link[rel="manifest"]');
    if (!link?.href) {
        return;
    }
    fetch(link.href)
        .then(response => {
            if (!response.ok) {
                console.error(`Web app manifest returned ${response.status} (${link.href})`);
            }
        })
        .catch((error: unknown) => {
            console.error(`Web app manifest unreachable (${link.href}): ${error instanceof Error ? error.message : String(error)}`);
        });
}
